
  export default {
    data () {
      return {
        tooltipContent: 'Copy'
      };
    },
    computed: {
      header () {
        if (this.modelName === 'homeInsuranceSearch') {
          return this.$t('home-quote');
        } else {
          return this.$t('motor-quote');
        }
      },
      quoteRef () {
        if (this.modelName === 'homeInsuranceSearch') {
          return `HIQ-${this.search['code']}`;
        } else {
          return `CIQ-${this.search['code']}`;
        }
      },
      search () {
        return this.$store.getters['search/get'];
      }
    }
  };
